import { handlePropsDynamicUrl, handleSelectDataSource, handleSelectRequestConfig, setAdvancedConfigToProps, } from '@/common/util/util';
import { forwardRef } from 'react';
import { CnComplexRadioGroup, CnRadioGroup, componentMap as formComponentMap, formilyReact, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
import isPlainObject from 'lodash/isPlainObject';
import { handleBizExtendComponentProps } from '@/common/manager/plugin';
const { useField } = formilyReact || {};
export const config = {
    position: [
        DisplayPosition.filter,
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'RadioGroup',
    component: (props) => {
        const { extra, ...rest } = props || {};
        const { type } = extra || {};
        let shape;
        if (type === 'complex') {
            return <CnComplexRadioGroup {...rest}/>;
        }
        if (['button', 'tag'].includes(type)) {
            shape = type;
        }
        return <CnRadioGroup shape={shape} {...rest}/>;
    },
    formComponent: forwardRef((props, ref) => {
        const field = useField?.();
        handlePropsDynamicUrl(props, {
            field,
        });
        const { extra, ...rest } = props || {};
        const { type } = extra || {};
        let shape;
        if (type === 'complex') {
            return <formComponentMap.CnComplexRadioGroup {...rest}/>;
        }
        if (['button', 'tag'].includes(type)) {
            shape = type;
        }
        return <formComponentMap.CnRadioGroup shape={shape} {...rest} ref={ref}/>;
    }),
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        const tempProps = formItem?.['x-component-props'];
        if (isPlainObject(tempProps)) {
            tempProps.getRequestParams = () => {
                return {
                    state,
                    recordDataSource: formValue,
                };
            };
            const { extra } = tempProps;
            const { direction } = extra || {};
            if (direction) {
                tempProps.direction = direction;
            }
        }
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
            handleDynamicUrl: true,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
            recordDataSource: formValue,
        });
        const componentProps = formItem?.['x-component-props'];
        handleBizExtendComponentProps(componentProps, 'CnRadioGroup');
        setAdvancedConfigToProps(componentProps);
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        handleSelectRequestConfig(config);
        handleSelectDataSource(config);
    },
};
